import { apiClientV2 } from '@/services/rest-api/apiClient'
const baseURL = process.env.VUE_APP_API_FLEET_PLANNING_URL

export const get = async (queryParam) => {
  const params = {
    limit: queryParam.limit,
    page: queryParam.page,
    search: queryParam?.search || undefined,
    available: queryParam?.filterButton,
    user_group_id: queryParam?.user_group_id || undefined,
    vehicle_category: queryParam?.vehicle_category || undefined,
  }

  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: '/driver',
    params,
  })

  return response?.data
}
